import { render, staticRenderFns } from "./GetDetails.vue?vue&type=template&id=52264d62&scoped=true&"
import script from "./GetDetails.vue?vue&type=script&lang=ts&"
export * from "./GetDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52264d62",
  null
  
)

export default component.exports